(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cc-collection-tabs"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.cc-tabs').forEach(function(t){
  if(t.dataset.ready)return;t.dataset.ready='1';
  var tabs=[].slice.call(t.querySelectorAll('[role=tab]'));
  function select(x){tabs.forEach(function(y){var on=y===x;y.setAttribute('aria-selected',on);y.tabIndex=on?0:-1;var p=document.getElementById(y.getAttribute('aria-controls'));if(p)p.hidden=!on})}
  tabs.forEach(function(x,i){x.addEventListener('click',function(){select(x)});x.addEventListener('keydown',function(e){if(e.key==='ArrowRight'||e.key==='ArrowLeft'){var n=tabs[(i+1)%tabs.length];select(n);n.focus()}})});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cc-grid-inserts"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-cc-inserts]').forEach(function(h){
  if(h.dataset.ready)return;h.dataset.ready='1';
  var t=document.getElementById(h.dataset.ccInserts);if(!t)return;
  function run(){
    var grid=document.querySelector(h.dataset.grid||'.product-grid');if(!grid||grid.dataset.ccInserted)return;
    var items=[].slice.call(t.content.querySelectorAll('[data-cc-insert]')).sort(function(a,b){return a.dataset.ccInsert-b.dataset.ccInsert});
    items.forEach(function(it){var n=Number(it.dataset.ccInsert)-1,kids=grid.children,node=it.cloneNode(true);node.classList.add('cc-insert');if(n<kids.length)grid.insertBefore(node,kids[n]);else grid.appendChild(node)});
    grid.dataset.ccInserted='1';if(window.CC)window.CC.init(grid);
  }
  run();new MutationObserver(function(){run()}).observe(document.getElementById('MainContent')||document.body,{childList:true,subtree:true});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
